import type { Exam } from './types';

/**
 * Führt diese Prüfung Schauspieler — und zeigt der Startablauf deshalb die dritte Spalte?
 *
 * **Vorgabe des Nutzers, 2026-09-17:** *„Wenn die Prüfung keine Schauspieler hat, sollte es
 * ausgeblendet werden — wenn die Prüfung Schauspieler assoziiert hat, wird die Auswahl
 * angezeigt. Eine Option ist nicht nötig, der Server/die Prüfung entscheidet."*
 *
 * ⚠️ **Bis dahin gab es dafür einen Schalter** (`sheet_show_actors`), und der konnte beides
 * falsch: eine Spalte zeigen, in der nichts steht, oder eine verstecken, obwohl die Prüfung
 * Schauspieler mitbringt. Nachziehen musste ihn jemand, der die Prüfung gar nicht kennt — am
 * iPad oder über die Geräteverwaltung. Die Prüfung selbst weiss es ohnehin.
 *
 * ⚠️ **Herausgelöst aus dem Bauteil**, damit sich der Entscheid ohne React prüfen lässt —
 * dasselbe Vorgehen wie bei `annotateSave.ts` und `loeschScharf.ts`.
 *
 * Ohne Prüfung ist die Antwort `false`: vor der ersten Wahl gibt es nichts anzuzeigen, und eine
 * leere dritte Spalte sähe aus wie ein Ladefehler.
 */
export function fuehrtSchauspieler(exam: Exam | null | undefined): boolean {
  return (exam?.actors.length ?? 0) > 0;
}
